export default function brand_details()
{
    return({
        //Company Information
        name: "Bolide SOC",
        subtitle: "Enterprise Orchestrator",
        sub_entity_name: "REimagine",
        
        //Logo Information
        logo:getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
}